import { EPaymentMethod, TPaymentMethodCreate, IPaymentManualEntryCreate } from "../../../invoice/create/interfaces/invoice.interfaces";

type StoredBankTransfer = Partial<{
  accountHolderName: string;
  routingNumber: string | number;
  accountNumber: string | number;
}>;

const readBankTransferFromStorage = (): StoredBankTransfer | null => {
  try {
    const raw = localStorage.getItem("bankTransfer.details.default");
    if (!raw) return null;
    return JSON.parse(raw);
  } catch {
    return null;
  }
};

interface PaymentMethodInput {
  selectedPayments: string[];
  referenceNumber: string;
  markAsPaid: boolean;
  manualEntryNotes?: string;
  manualEntryTransactionId?: string;
}

export const mapPaymentMethodsToBackend = ({
  selectedPayments,
  referenceNumber,
  markAsPaid,
  manualEntryNotes,
  manualEntryTransactionId,
}: PaymentMethodInput): TPaymentMethodCreate[] => {
  const paymentMethods: TPaymentMethodCreate[] = [];

  selectedPayments.forEach((paymentId) => {
    const id = paymentId.toLowerCase();

    if (id === "paypal") {
      paymentMethods.push({ provider: EPaymentMethod.PAYPAL });
      return;
    }

    if (id === "stripe") {
      paymentMethods.push({ provider: EPaymentMethod.STRIPE });
      return;
    }

    if (id === "bank_transfer") {
      const stored = readBankTransferFromStorage();
      const accountHolderName = String(stored?.accountHolderName ?? "").trim() || "Bank Transfer";
      const routingNumber = String(stored?.routingNumber ?? referenceNumber ?? "").trim() || "N/A";
      const accountNumberRaw = stored?.accountNumber ?? "";
      const accountNumber = String(accountNumberRaw).trim() || undefined;

      paymentMethods.push({
        provider: EPaymentMethod.BANK_TRANSFER,
        bankTransferInfo: {
          routingNumber,
          accountHolderName,
          ...(accountNumber ? { accountNumber } : {}),
        },
      });
      return;
    }
  });

  if (markAsPaid) {
    const manualEntry: IPaymentManualEntryCreate = { provider: EPaymentMethod.MANUAL_ENTRY };
    if (manualEntryNotes) manualEntry.notes = manualEntryNotes;
    if (manualEntryTransactionId) manualEntry.transactionId = manualEntryTransactionId;
    paymentMethods.push(manualEntry);
  }

  return paymentMethods;
};
